import { Model } from '@models';

export class ReturnReason extends Model {
  title: string;
  subReason: ReturnReason;
}
